exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/src/app/layouts/full-layout.component.scss
// module id = ../../../../../src/app/layouts/full-layout.component.scss
// module chunks = 7